<template>
  <RevButton :loading variant="primary" @click="handleClick">
    <slot />
  </RevButton>
</template>

<script setup lang="ts">
import { navigateTo, useRoute } from '#imports'
import { ref } from 'vue'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useTheToast } from '@backmarket/nuxt-module-toast/useTheToast'
import { RevButton } from '@ds/components/Button'

import { CHECKOUT } from '~/scopes/checkout/routes-names'

const props = defineProps<{
  cartSelectionId: string
}>()

const $httpFetch = useHttpFetch()
const { openErrorToast } = useTheToast()
const route = useRoute()

const loading = ref(false)

async function handleClick() {
  try {
    loading.value = true
    await $httpFetch(
      '/api/mobile-plan/in-store/v1/cart-selections/:cartSelectionId/cancel',
      {
        method: 'POST',
        pathParams: {
          cartSelectionId: props.cartSelectionId,
        },
      },
    )

    await navigateTo(
      {
        name: CHECKOUT.IN_STORE_SALES.BOUYGUES_TELECOM.SELF,
        params: { magicLinkId: route.params.magicLinkId },
      },
      { external: true },
    )
  } catch {
    openErrorToast()
  } finally {
    loading.value = false
  }
}
</script>
